import { Flex, Stack } from '@mantine/core';
import { IconUserFilled } from '@tabler/icons-react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PageHeader } from '../../components/PageHeader';
import { Paper } from '../../components/Paper';
import { LIGHT_GREY } from '../../const/constants';
import { query } from '../../util/api/query';
import {
	CustomerAddress,
	CustomerBankInformation,
	CustomerDetails,
	CustomerGeneralInformation,
} from './components/SingleCustomerTiles';
import type { FullCustomerDto } from './types/CustomerDto';

export function SingleCustomer() {
	const { id, organisation } = useParams();

	useEffect(() => {
		document.body.style.backgroundColor = LIGHT_GREY;
	}, []);

	const customerQuery = query<FullCustomerDto>(
		`${organisation}/customers/id/${id}`,
	);

	return (
		<>
			<PageHeader
				title={
					customerQuery.data
						? `${customerQuery.data?.value.firstName} ${customerQuery.data?.value.lastName}`
						: 'Undefined'
				}
				icon={<IconUserFilled color={'grey'} />}
				hideFiltering
			/>
			<Flex w={'100%'} h={'100%'} dir={'column'} gap={20}>
				<Stack w={'50%'}>
					<Paper title={'General Information'}>
						<CustomerGeneralInformation customerQuery={customerQuery} />
					</Paper>
					<Paper title={'Customer Details'}>
						<CustomerDetails customerQuery={customerQuery} />
					</Paper>
				</Stack>
				<Stack w={'50%'}>
					<Paper title={'address'}>
						<CustomerAddress customerQuery={customerQuery} />
					</Paper>
					<Paper title={'Bank Account Details'}>
						<CustomerBankInformation customerQuery={customerQuery} />
					</Paper>
				</Stack>
			</Flex>
		</>
	);
}
